import {OrderDetail} from "../../types/order";
import ReactPixel from "react-facebook-pixel";

export function useMetaPixel() {
    const trackPurchase = (orderDetail: OrderDetail) => {
        console.log('주문 수집중')
        ReactPixel.track('Purchase', {
            value: orderDetail?.payAmount,
            currency: 'KRW',
            content_ids: [orderDetail.idx],
            order_id: orderDetail?.idx,
            content_type: 'product',
            product_name: orderDetail.orderTitle
        });
    };

    return {
        trackPurchase
    }
}